import axios from '../axios'

/* 
 * 备注信息管理
 */

/**
 * 查询历史备注信息
 * @param {*} service   服务模块 例：admin
 * @param {*} params    请求参数
 * @returns 
 */
export const findStringRemark = (service, params) => {
  let tempUrl = ''
  if (service && service !== '') {
    tempUrl = '/' + service + '/remark/findStringRemark';
  } else {
    tempUrl = '/remark/findStringRemark';
  }
  return axios({
    url: tempUrl,
    method: 'get',
    params
  })
}

/**
 * 根据记录id获取历史备注信息列表，按创建时间排序
 * @param {*} service   服务模块 例：admin
 * @param {*} params    请求参数
 * @returns 
 */
export const findRemarkById = (service, params) => {
  let tempUrl = ''
  if (service && service !== '') {
    tempUrl = '/' + service + '/remark/findRemarkByRecordId';
  } else {
    tempUrl = '/remark/findRemarkByRecordId';
  }
  return axios({
    url: tempUrl,
    method: 'get',
    params
  })
}

/**
 * 单个新增备注信息
 * @param {*} service   服务模块 例：admin
 * @param {*} data    请求参数
 * @returns 
 */
export const insertRemark = (service, data) => {
  let tempUrl = ''
  if (service && service !== '') {
    tempUrl = '/' + service + '/remark/insertRemarkInfo';
  } else {
    tempUrl = '/remark/insertRemarkInfo';
  }
  return axios({
    url: tempUrl,
    method: 'post',
    data
  })
}

/**
 * 批量新增备注信息
 * @param {*} service   服务模块 例：admin
 * @param {*} data    请求参数
 * @returns 
 */
export const insertRemarkInfoBatch = (service, data) => {
  let tempUrl = ''
  if (service && service !== '') {
    tempUrl = '/' + service + '/remark/insertRemarkInfoBatch';
  } else {
    tempUrl = '/remark/insertRemarkInfoBatch';
  }
  return axios({
    url: tempUrl,
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/common/remark.js